/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class OperationTypeField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [{ key: 1, text: 'App', value: 'App' }, { key: 2, text: 'Call', value: 'Call' }]

    return (
      <Form.Select
        required
        fluid
        label="Operation Type"
        options={options}
        placeholder="App/Call"
        onChange={(e, data) => onChange('operation_type', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/operationField.js